import { ZodShape } from '@client/new/helpers/types';
import {
  ContentAccessMethod,
  CreateLinkInput,
  UpdateLinkInput,
} from 'generated/graphql';
import { commonInputShape, commonUpdateShape } from '../pdf/pdf.schema';
import { z } from 'zod';
import {
  createStringValidator,
  optionalUrlValidator,
  urlValidator,
} from '../pdf/zod.utils';

const maxTitleLength = 500;
const minContentLength = 1;

const createLinkInputShape: ZodShape<CreateLinkInput> = {
  ...commonInputShape,
  title: createStringValidator(minContentLength, maxTitleLength, 'Link title'),
  coverImage: optionalUrlValidator.nullable(),
  url: urlValidator,
};

export const createLinkInputSchema = z.object(createLinkInputShape);

const editLinkInputShape: ZodShape<UpdateLinkInput> = {
  ...commonUpdateShape,
  title: createStringValidator(minContentLength, maxTitleLength, 'Link title'),
  coverImage: optionalUrlValidator.nullable(),
  accessMethod: z.nativeEnum(ContentAccessMethod).optional(),
  url: urlValidator,
  isArchived: z.boolean().optional(),
};

export const updateLinkInputSchema = z.object(editLinkInputShape);
